let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jbAqH")).then(() => parcelRequire('eVad5'));